import { SocialLinks, FlagImage } from "./SocialLinks";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-16 pb-10 px-6 mt-20 border-t border-white/8"
    >
      <div className="max-w-3xl mx-auto text-center">
        <SocialLinks />

        <div className="mt-10 flex justify-center" data-testid="us-flag">
          <FlagImage className="h-14 md:h-16" />
        </div>

        <p className="mt-8 text-white/40 text-[12px]">
          © 2026 Councilman Wood. All rights reserved. · Serving the Vineyard community
        </p>
      </div>
    </footer>
  );
};
